import { useBulkActionsContext } from '../components/BulkActionsProvider';
export const useIsBulkActionsRedesignEnabled = () => {
  const context = useBulkActionsContext();
  if (!context) {
    return false;
  }
  try {
    const {
      isBulkActionsRedesignEnabled
    } = context;
    return isBulkActionsRedesignEnabled;
  } catch (error) {
    return false;
  }
};